module.exports = __webpack_public_path__ + "img/normal-you2.9144354a.png";